import { Enumify } from "enumify-ts";
class DriverFatigueBreachCause extends Enumify() {
    description;
    static MAX_HOURS = new DriverFatigueBreachCause("Max Hours Reached");
    static BREAK_OVERDUE = new DriverFatigueBreachCause("Break Overdue");
    static _ = DriverFatigueBreachCause._closeEnum();
    constructor(description) {
        super();
        this.description = description;
    }
}
export default DriverFatigueBreachCause;
